import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountCustomerPayments,
  getAccountCustomerPayment,
  createAccountCustomerPayment,
  updateAccountCustomerPayment,
  deleteAccountCustomerPayment,
} from "api/accountCustomerPaymentApi"

export const ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY = "account-customer-payments"

export const useAccountCustomerPayments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY,
    getAccountCustomerPayments,
    params,
    enabled
  )
}

export const useAccountCustomerPayment = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY,
    getAccountCustomerPayment,
    id,
    enabled
  )
}

export const useCreateAccountCustomerPayment = () => {
  return useCreateResource(
    createAccountCustomerPayment,
    ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY
  )
}

export const useEditAccountCustomerPayment = () => {
  return useEditResource(
    updateAccountCustomerPayment,
    ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY
  )
}

export const useDeleteAccountCustomerPayment = () => {
  return useDeleteResource(
    deleteAccountCustomerPayment,
    ACCOUNT_CUSTOMER_PAYMENT_QUERY_KEY
  )
}
